"use client"

import * as TogglePrimitive from "@radix-ui/react-toggle"
import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"

import { cn } from "../../utils"

const toggleVariants = cva(
	"inline-flex items-center justify-center gap-1 rounded-lg text-sm text-text [&_svg]:fill-current cursor-pointer disabled:pointer-events-none [&_svg]:shrink-0 outline-none transition-all whitespace-nowrap",
	{
		variants: {
			size: {
				xsmall: "h-6 min-w-6 px-2 text-xs rounded-md [&:has(>svg:only-child)]:px-1 [&_svg]:size-4",
				small: "h-8 min-w-8 px-3 text-sm rounded-md [&:has(>svg:only-child)]:px-1.5 [&_svg]:size-5",
				medium: "h-10 min-w-10 px-4 text-base [&:has(>svg:only-child)]:px-2.5 [&_svg]:size-5",
				large: "h-12 min-w-12 px-5 text-lg rounded-[10px] [&:has(>svg:only-child)]:px-3 [&_svg]:size-6"
			},
			color: {
				default:
					"bg-transparent hover:bg-g800/10 active:bg-g800/30 dark:bg-transparent dark:hover:bg-g800/10 dark:active:bg-g800/30 disabled:bg-g200 disabled:text-g400 dark:disabled:bg-g200 dark:disabled:text-g400 data-[state=on]:bg-g300 dark:data-[state=on]:bg-g300 dark:data-[state=on]:disabled:bg-g200",
				line: "bg-transparent hover:bg-g800/10 active:bg-g800/30 dark:bg-transparent dark:hover:bg-g800/10 dark:active:bg-g800/30 disabled:bg-g200 disabled:text-g400 dark:disabled:bg-g200 dark:disabled:text-g400 data-[state=off]:inset-ring-1 data-[state=off]:inset-ring-g800/10 data-[state=off]:text-text-secondary data-[state=off]:hover:text-text-secondary data-[state=on]:bg-g300 dark:data-[state=on]:bg-g300 dark:data-[state=on]:disabled:bg-g200"
			}
		},
		defaultVariants: {
			size: "medium",
			color: "default"
		}
	}
)

function Toggle({ className, size, color, ...props }: React.ComponentProps<typeof TogglePrimitive.Root> & VariantProps<typeof toggleVariants>) {
	return <TogglePrimitive.Root data-slot="toggle" className={cn(toggleVariants({ size, color, className }))} {...props} />
}

export { Toggle, toggleVariants }
